import { LanguageCodeEnum } from '@systemeio/ui'
import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import arCommon from './assets/locales/ar/translation.json'
import csCommon from './assets/locales/cs/translation.json'
import daCommon from './assets/locales/da/translation.json'
import deCommon from './assets/locales/de/translation.json'
import elCommon from './assets/locales/el/translation.json'
import enCommon from './assets/locales/en/translation.json'
import esCommon from './assets/locales/es/translation.json'
import frCommon from './assets/locales/fr/translation.json'
import hiCommon from './assets/locales/hi/translation.json'
import huCommon from './assets/locales/hu/translation.json'
import idCommon from './assets/locales/id/translation.json'
import itCommon from './assets/locales/it/translation.json'
import jaCommon from './assets/locales/ja/translation.json'
import nlCommon from './assets/locales/nl/translation.json'
import noCommon from './assets/locales/no/translation.json'
import plCommon from './assets/locales/pl/translation.json'
import ptCommon from './assets/locales/pt/translation.json'
import roCommon from './assets/locales/ro/translation.json'
import ruCommon from './assets/locales/ru/translation.json'
import skCommon from './assets/locales/sk/translation.json'
import slCommon from './assets/locales/sl/translation.json'
import sqCommon from './assets/locales/sq/translation.json'
import srCommon from './assets/locales/sr/translation.json'
import svCommon from './assets/locales/sv/translation.json'
import thCommon from './assets/locales/th/translation.json'
import trCommon from './assets/locales/tr/translation.json'
import ukCommon from './assets/locales/uk/translation.json'
import zhCommon from './assets/locales/zh/translation.json'

const ns = ['common']
const supportedLngs = Object.values(LanguageCodeEnum)

const resources = {
  ar: { common: arCommon },
  cs: { common: csCommon },
  da: { common: daCommon },
  de: { common: deCommon },
  el: { common: elCommon },
  en: { common: enCommon },
  es: { common: esCommon },
  fr: { common: frCommon },
  hi: { common: hiCommon },
  hu: { common: huCommon },
  id: { common: idCommon },
  it: { common: itCommon },
  ja: { common: jaCommon },
  nl: { common: nlCommon },
  no: { common: noCommon },
  pl: { common: plCommon },
  pt: { common: ptCommon },
  ro: { common: roCommon },
  ru: { common: ruCommon },
  sk: { common: skCommon },
  sl: { common: slCommon },
  sq: { common: sqCommon },
  sr: { common: srCommon },
  sv: { common: svCommon },
  th: { common: thCommon },
  tr: { common: trCommon },
  uk: { common: ukCommon },
  zh: { common: zhCommon },
}

const i18nOptions: InitOptions = {
  supportedLngs,
  load: 'languageOnly',
  debug: process.env.APP_ENV === 'development',
  defaultNS: ns[0],
  react: { useSuspense: false },
  returnEmptyString: false,
  ns,
  fallbackLng: LanguageCodeEnum.ENGLISH,
  lng: LanguageCodeEnum.ENGLISH,
  interpolation: {
    escapeValue: false,
  },
  resources,
}

i18n.use(initReactI18next).init(i18nOptions)

export default i18n
